import * as React from "react";
import Api, {APIs} from "../../../Api";
import {Box, Dialog, DialogContent, Paper} from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

interface IProp {
    pid: number
}

const ProjectPictures = (props: IProp) => {
    const [itemData, setItemData] = React.useState([])
    const [open, setOpen] = React.useState(false);
    const [selectedImage, setSelectedImage] = React.useState("#")
    // const query = useQuery()
    // const pid = query.get('id')
    React.useEffect(() => {
        if (props.pid) {
            Api.get(APIs.EAD_PROJECT_PHOTOS, {pid: props.pid}).then((payload) => {
                if (payload) {
                    setItemData(payload)
                }
            })
        }
    }, [])
    const handleClose = () => {
        setOpen(false);
    };
    const handleImageClick = (item: string) => {
        setSelectedImage(Api.getMediaURL(item))
        setOpen(true);

    }
    return (
        <Paper elevation={6} sx={{flex: 1, p: 1, m: 2}}>
            {itemData.length > 0 ?
                <React.Fragment>
                    <ImageList variant="masonry" cols={3} gap={8}>
                        {itemData.map((item, index) => (
                            <ImageListItem key={item} onClick={() => {
                                handleImageClick(itemData[index])
                            }}>
                                <img
                                    src={Api.getMediaURL(item)}
                                    srcSet={Api.getMediaURL(item)}
                                    // alt={item.title}
                                    loading="lazy"
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                    <Dialog open={open} onClose={handleClose} maxWidth={'xl'}>
                        <DialogContent>
                            <Box
                                component="img"
                                sx={{
                                    // width: 600,
                                    position: 'center',
                                    // maxHeight: { xs: 233, md: 167 },
                                    maxWidth: {xs: 230, sm: 350, md: 500, lg: 700, xl: 800},
                                }}
                                alt=" "
                                src={selectedImage}
                            />
                            {/*<img src={selectedImage} height={'100%'}/>*/}
                        </DialogContent>
                    </Dialog>
                </React.Fragment>
                : <Box sx={{
                    display: "flex", height: "100%",
                    flex: 1, justifyItems: "center", justifyContent: "center"
                }}>
                    No Photo Available </Box>}
        </Paper>
    );
}

export default ProjectPictures
